import styled from "@rentiohq/web-theme";

export const Mark = styled.mark`
  padding: 0 1px;
  border-radius: 2px;
  background: ${({ theme }) => theme.getColor("yellow", "400")};
  color: inherit;
`;
